import { Controller } from "@hotwired/stimulus"

// Marks the first visible variant row as the control (its `.control-tag` gets `is-control`), and keeps it
// correct as the list changes — drag-reorder, add, or remove. The draggable-list controller only rewrites
// the `ordering` inputs on drop; this reflects the resulting order in the UI. Uses a MutationObserver so it
// covers every mutation path (reorder, nested-form add/remove) without wiring an action to each one.
export default class extends Controller {
  connect() {
    this.markControl()
    this.observer = new MutationObserver(() => this.markControl())
    this.observer.observe(this.element, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class"],
    })
  }

  disconnect() {
    this.observer?.disconnect()
  }

  markControl() {
    const items = Array.from(this.element.querySelectorAll(".list-item"))
    const control = items.find((item) => !item.classList.contains("hidden"))
    items.forEach((item) => {
      item.querySelector(".control-tag")?.classList.toggle("is-control", item === control)
    })
  }
}
